import type { ImmutableMap } from 'js/src/libs/consts';

export enum ANALYTICS_ACTIONS {
    INITIALIZE_TAB_DURATIONS = 'INITIALIZE_TAB_DURATIONS',
    SYNC_DURATION = 'SYNC_DURATION',
}

export type TabDurationStore = ImmutableMap<{
    media_tab_duration: number;
    music_tab_duration: number;
    style_tab_duration: number;
    format_tab_duration: number;
    voiceover_tab_duration: number;
    original_content_tab_duration: number;
}>;
